<!-- User Fia Pin Modal -->
<div
  style="overflow-y: auto"
  mdbModal
  #userTradeHistory="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
  (close)="onClosed($event)"
>
  <div class="modal-dialog modal-fluid" role="document" *ngIf="showModal">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="showHideModal(false)">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">{{ userProfile.fullName }} - Trade History</h4>
      </div>
      <div class="modal-body">
        <mdb-card class="mb-2 wow fadeIn">
          <div class="card-header">
            <div class="row px-2">
              <div class="md-form my-auto col-sm-12 col-md-3 col-lg-3">
                <select
                  class="md-form form-control browser-default w-100"
                  id="dateFilter"
                  (change)="GetTradeHistory()"
                  [(ngModel)]="transactionSearchRequest.dateFilter"
                  placeholder="Date range"
                >
                  <option *ngFor="let date of DateFilter" [ngValue]="date.Id">{{ date.Name }}</option>
                </select>
                <label for="dateFilter" class="active">Date range</label>
              </div>
              <div class="md-form col-sm-12 col-md-9 col-lg-9 text-right">
                <button
                  type="button"
                  mdbBtn
                  color="blue"
                  outline="false"
                  rounded="true"
                  size="sm"
                  (click)="Extract('UserTransactions')"
                  class="px-4"
                  mdbWavesEffect
                >
                  <mdb-icon fas icon="cloud-download-alt"></mdb-icon> Extract
                </button>
                <button mdbBtn size="sm" class="btn-trakly-action" (click)="GetTradeHistory()">Search</button>
              </div>
            </div>
          </div>

          <div class="card-header p1">
            <div class="row mt-0">
              <div class="col">
                <mdb-card>
                  <mdb-card-header class="p-1 text-center" style="background-color: #ffdc67">
                    <h6 class="small">Total Profit</h6>
                  </mdb-card-header>
                  <mdb-card-body class="p-1 text-center">
                    <p>R {{ totalProfit | number: "1.2-2" }}</p>
                  </mdb-card-body>
                </mdb-card>
              </div>
              <div class="col">
                <mdb-card>
                  <mdb-card-header class="p-1 text-center" style="background-color: #1976d2">
                    <h6 class="small white-text">Avg Trade Profit</h6>
                  </mdb-card-header>
                  <mdb-card-body class="p-1 text-center">
                    <p>R {{ averageTradeProfitZar | number: "1.2-2" }}</p>
                  </mdb-card-body>
                </mdb-card>
              </div>
              <div class="col">
                <mdb-card>
                  <mdb-card-header class="p-1 text-center" style="background-color: #ffdc67">
                    <h6 class="small">Avg Profit Percentage</h6>
                  </mdb-card-header>
                  <mdb-card-body class="p-1 text-center">
                    <p>{{ averageProfitPercentage | number: "1.2-2" }}</p>
                  </mdb-card-body>
                </mdb-card>
              </div>
              <div class="col">
                <mdb-card>
                  <mdb-card-header class="p-1 text-center" style="background-color: #1976d2">
                    <h6 class="small white-text">Total Trades</h6>
                  </mdb-card-header>
                  <mdb-card-body class="p-1 text-center">
                    <p>{{ transactions.length }}</p>
                  </mdb-card-body>
                </mdb-card>
              </div>
              <div class="col">
                <mdb-card>
                  <mdb-card-header class="p-1 text-center" style="background-color: #ffdc67">
                    <h6 class="small">FIA Traded</h6>
                  </mdb-card-header>
                  <mdb-card-body class="p-1 text-center">
                    <p>R {{ totalFIAUsed | number: "1.0" }}</p>
                  </mdb-card-body>
                </mdb-card>
              </div>
              <div class="col">
                <mdb-card>
                  <mdb-card-header class="p-1 text-center" style="background-color: #1976d2">
                    <h6 class="small white-text">SDA Traded</h6>
                  </mdb-card-header>
                  <mdb-card-body class="p-1 text-center">
                    <p>R {{ totalSDAUsed | number: "1.0" }}</p>
                  </mdb-card-body>
                </mdb-card>
              </div>
              <div class="col">
                <mdb-card>
                  <mdb-card-header class="p-1 text-center" style="background-color: #1976d2">
                    <h6 class="small white-text">Total Traded</h6>
                  </mdb-card-header>
                  <mdb-card-body class="p-1 text-center">
                    <p>R {{ totalTraded | number: "1.0" }}</p>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </div>
          </div>
        </mdb-card>
        <div *ngIf="!busy">
          <!--Error Display-->
          <div class="col">
            <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
              {{ errorMsg }}
            </div>
          </div>
          <mdb-card *ngIf="transactions.length" class="mb-4 mt-2 wow fadeIn" cascade="true" narrower="true">
            <div *ngIf="!busy && transactions.length > 0" class="table-responsive">
              <table mdbTable hover="true" id="UserTransactions" class="table-sm">
                <thead>
                  <tr>
                    <th scope="col">Profit</th>
                    <th scope="col">Profit %</th>
                    <th scope="col">Trade amount</th>
                    <th scope="col">Start Date</th>
                    <th scope="col">Completion Date</th>
                    <th scope="col">Status</th>
                    <th scope="col">FIA Amount</th>
                    <th scope="col">SDA Amount</th>
                  </tr>
                </thead>
                <tbody mdbTableCol *ngFor="let trans of transactions">
                  <tr (click)="toggleFiaPinsTable(trans)">
                    <td *ngIf="trans.totalProfit >= 0">
                      <mdb-icon size="lg" fas icon="angle-up green-text"></mdb-icon> R
                      {{ trans.totalProfit | number }}
                    </td>
                    <td *ngIf="trans.totalProfit < 0">
                      <mdb-icon size="lg" fas icon="angle-down red-text"></mdb-icon> R
                      {{ trans.totalProfit | number }}
                    </td>
                    <td>{{ trans.totalProfitPercentage | number }}%</td>
                    <td>R {{ trans.amountSent | number }}</td>
                    <td>{{ trans.transactionStartDate | date }}</td>
                    <td>{{ trans.transactionEndDate | date }}</td>
                    <td>
                      <span mdbTooltip="{{ GetHoverHelpText(trans.transactionStatus.id) }}">
                        {{ GetStatusDisplayName(trans.transactionStatus.id) }}
                      </span>
                    </td>
                    <td>R {{ trans.fiaAmount | number }}</td>
                    <td>R {{ trans.sdaAmount | number }}</td>
                  </tr>
                  <tr *ngIf="trans.transactionUserFiaPins.length > 0 && trans.selected">
                    <td colspan="100%" style="border: 0 !important">
                      <table mdbTable colspan="100%" style="border: 0 !important">
                        <thead>
                          <tr>
                            <th scope="col">Pin</th>
                            <th scope="col">Pin Amount</th>
                            <th scope="col">Amount Used</th>
                          </tr>
                        </thead>
                        <tbody *ngFor="let pin of trans.transactionUserFiaPins">
                          <tr>
                            <td>{{ pin.userFiaPin.pin }}</td>
                            <td>{{ pin.userFiaPin.pinAmount }}</td>
                            <td>{{ pin.amountUsed }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-template #tradeAmountPopTemplate>Inc. R500 SWIFT fee</ng-template>
          </mdb-card>

          <div class="w-100 text-center" *ngIf="!busy && transactions.length == 0">
            <img src="../../../../assets/img/Spreadsheet.svg" class="col-sm-3 mx-auto d-block" alt="1" />
            <h2 class="text-center">We didn't find any trades...</h2>
            <p>We'll show the details of each trade here as soon as we get them.</p>
          </div>

          <!--Loading display-->
          <div *ngIf="busy" class="col-12 text-center">
            <app-loading [busy]="busy"></app-loading>
          </div>
        </div>
        <!--Loading-->
        <div *ngIf="busy" class="col-12 text-center">
          <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
